import React from 'react';

import "react-toastify/dist/ReactToastify.css";
import Image from "react-bootstrap/Image";
import Helmet from "react-helmet";
import logo from "./../../images/logo_2021.svg";
import "./header.css";

const AppSuperBar = props => {

  return (
    <>
      <Helmet>
        <title>Guia de Servicios</title>
        <meta name="description" content={"Superintendencia de Salud"} />
      </Helmet>

      <header className="d-flex header-resposive-ss" >

        <Image src={logo} className="logo-responsive"   style={{ maxWidth: '12rem' }}  />

      </header>

    </>
  );
}

export default AppSuperBar;


